'use strict';

/**
 * 商品ページのリングサイズ variant-picker の選択値を
 * 「お問い合わせ」リンクの contact[ご希望サイズ] パラメータへ反映する。
 */
(() => {
  const RING_SIZE_OPTION_NAME = 'リングサイズ';
  const QUERY_PARAM = 'contact[ご希望サイズ]';
  const INQUIRY_LINK_SELECTOR = '[data-hrd-inquiry-link]';

  function getRingSizeValue(variantPicker) {
    const select = variantPicker.querySelector(`select[name="options[${RING_SIZE_OPTION_NAME}]"]`);
    if (select && select.value) return select.value;

    const legends = variantPicker.querySelectorAll('fieldset.variant-option legend');
    for (const legend of legends) {
      if (!legend.textContent.trim().startsWith(RING_SIZE_OPTION_NAME)) continue;

      const checked = legend.closest('fieldset')?.querySelector('input:checked');
      if (checked instanceof HTMLInputElement) return checked.value;
    }

    return '';
  }

  function updateInquiryLinks(value) {
    const formattedValue = value ? `${value}号` : '';

    document.querySelectorAll(INQUIRY_LINK_SELECTOR).forEach((link) => {
      if (!(link instanceof HTMLAnchorElement)) return;

      try {
        const url = new URL(link.href, window.location.origin);
        if (formattedValue) {
          url.searchParams.set(QUERY_PARAM, formattedValue);
        } else {
          url.searchParams.delete(QUERY_PARAM);
        }
        link.href = url.toString();
      } catch (_error) {
        // href が不正な場合は何もしない
      }
    });
  }

  function handleVariantSelected(event) {
    const variantPicker = event.target;
    if (!(variantPicker instanceof HTMLElement)) return;
    if (variantPicker.dataset.templateProductMatch !== 'true') return;

    updateInquiryLinks(getRingSizeValue(variantPicker));
  }

  function init() {
    const mainVariantPicker = document.querySelector('variant-picker[data-template-product-match="true"]');
    if (mainVariantPicker) {
      updateInquiryLinks(getRingSizeValue(mainVariantPicker));
    }

    document.addEventListener('variant:selected', handleVariantSelected);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
